<div class="sidebar-header px-4 pt-4 pb-2">
  <div class="d-flex align-items-center gap-2" [class.justify-content-center]="isCollapsed">
    <div class="logo-box bg-white p-1 flex-shrink-0">
      <img src="./assets/logo.png" width="50" height="50" alt="Logo" style="object-fit: contain" />
    </div>
    @if (!isCollapsed) {
      <div class="logo-text">
        <h6 class="mb-0 fw-800 text-white letter-spacing-1">ENJOCHEM</h6>
        <small class="text-white opacity-50 fw-bold" style="font-size: 10px">ERP ADMIN</small>
      </div>
    }
  </div>
</div>

<div
  class="collapse-toggle-wrap d-none d-xl-flex mb-2"
  [class.justify-content-center]="isCollapsed"
  [class.justify-content-end]="!isCollapsed">
  <button
    class="collapse-toggle-btn"
    #collapseTip="ngbTooltip"
    (click)="toggleCollapse(); collapseTip.close()"
    [ngbTooltip]="isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'"
    placement="right"
    container="body"
    tooltipClass="sidebar-tooltip"
    [openDelay]="150"
    [attr.aria-label]="isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'">
    <i class="bi" [class.bi-chevron-double-left]="!isCollapsed" [class.bi-chevron-double-right]="isCollapsed"></i>
  </button>
</div>

<div class="sidebar-body px-2">
  @for (group of menuGroups; track group.title) {
    <div class="nav-group">
      @if (!isCollapsed && group.title) {
        <small
          class="nav-group-title text-white opacity-25 text-uppercase fw-800 letter-spacing-1 mb-1 d-block ps-3"
          style="font-size: 10px">
          {{ group.title }}
        </small>
      }
      <ul class="list-unstyled">
        @for (item of group.items; track item.label) {
          <li class="sidebar-item mb-1">
            <a
              [routerLink]="item.route"
              routerLinkActive="active"
              class="nav-link d-flex align-items-center px-3 py-2 text-decoration-none transition-all"
              [class.justify-content-center]="isCollapsed"
              [ngbTooltip]="item.label"
              placement="right"
              container="body"
              tooltipClass="sidebar-tooltip"
              [openDelay]="150"
              [disableTooltip]="!isCollapsed"
              [attr.aria-label]="isCollapsed ? item.label : null"
              #navTip="ngbTooltip"
              (click)="toggleSidebar(); navTip.close()">
              <i class="bi fs-5" [ngClass]="item.icon" [class.me-3]="!isCollapsed"></i>
              @if (!isCollapsed) {
                <span class="fw-600">{{ item.label }}</span>
              }
            </a>
          </li>
        }
      </ul>
    </div>
  }

  <div class="nav-group mt-auto">
    @if (!isCollapsed) {
      <small
        class="nav-group-title text-white opacity-25 text-uppercase fw-800 letter-spacing-1 mb-1 d-block ps-3"
        style="font-size: 10px">
        Account
      </small>
    }
    <ul class="list-unstyled">
      <li class="sidebar-item mb-1">
        <a
          routerLink="/settings"
          routerLinkActive="active"
          class="nav-link d-flex align-items-center px-3 py-2 text-decoration-none transition-all"
          [class.justify-content-center]="isCollapsed"
          ngbTooltip="Settings"
          placement="right"
          container="body"
          tooltipClass="sidebar-tooltip"
          [openDelay]="150"
          [disableTooltip]="!isCollapsed"
          [attr.aria-label]="isCollapsed ? 'Settings' : null"
          #settingsTip="ngbTooltip"
          (click)="toggleSidebar(); settingsTip.close()">
          <i class="bi bi-gear-wide-connected fs-5" [class.me-3]="!isCollapsed"></i>
          @if (!isCollapsed) {
            <span class="fw-600">Settings</span>
          }
        </a>
      </li>
      <li class="sidebar-item">
        <a
          role="button"
          class="nav-link d-flex align-items-center px-3 py-2 text-decoration-none text-danger logout-item transition-all"
          [class.justify-content-center]="isCollapsed"
          ngbTooltip="Logout"
          placement="right"
          container="body"
          tooltipClass="sidebar-tooltip"
          [openDelay]="150"
          [disableTooltip]="!isCollapsed"
          [attr.aria-label]="isCollapsed ? 'Logout' : null"
          #logoutTip="ngbTooltip"
          (click)="onLogout(); logoutTip.close()">
          <i class="bi bi-box-arrow-right fs-5" [class.me-3]="!isCollapsed"></i>
          @if (!isCollapsed) {
            <span class="fw-600">Logout</span>
          }
        </a>
      </li>
    </ul>
  </div>
</div>

@if (!isCollapsed) {
  <div class="sidebar-footer px-4 py-2">
    <p class="mb-0 text-center" style="font-size: 10px; color: rgba(255, 255, 255, 0.2); letter-spacing: 0.5px">
      Developed by
      <span style="color: rgba(255, 255, 255, 0.4); font-weight: 700">SCIREW</span>
    </p>
  </div>
}
